module.exports = __webpack_public_path__ + "img/circle.1c746336.svg";